import { render, staticRenderFns } from "./ModalPrintEstadoInternacion.vue?vue&type=template&id=062f027c&scoped=true&"
import script from "./ModalPrintEstadoInternacion.vue?vue&type=script&lang=js&"
export * from "./ModalPrintEstadoInternacion.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrintEstadoInternacion.vue?vue&type=style&index=0&id=062f027c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f027c",
  null
  
)

export default component.exports